import type { UserProps } from '@img-arena/consoles-api-dde'
import type { Column, Filter } from '@/components/table/base'

export const DDE_TABLE_COLUMNS: Column<UserProps>[] = [
  {
    type: 'text',
    id: 'userName',
    label: 'Username',
    sortAttribute: 'username'
  },
  {
    type: 'text',
    id: 'userId',
    label: 'Email',
    sortAttribute: 'email'
  },
  {
    type: 'text',
    id: 'role.roleName',
    label: 'Role',
    sortAttribute: 'role'
  },
  {
    type: 'text',
    id: 'role.operatorName',
    label: 'Operator',
    sortAttribute: 'operator'
  },
  {
    type: 'date',
    id: 'lastLogin',
    label: 'Last Active',
    sortAttribute: 'lastActive',
    dateFormat: 'dd-MM-yyyy HH:mm:ss'
  }
]

export const DDE_TABLE_FILTERS: Filter<UserProps>[] = [
  {
    type: 'freeTextSearch',
    paramName: 'ft',
    placeholder: 'Search',
    filterOptions: (row, search) => {
      if (!search) return true

      const lowerCaseSearch = search.toLowerCase()
      const { userName, userId } = row

      return (
        userName.toLowerCase().includes(lowerCaseSearch) ||
        userId.toLowerCase().includes(lowerCaseSearch)
      )
    }
  }
]
